import { c as _c } from "react/compiler-runtime";
import { IcoEmail24 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
export type EmailPreviewProps = {
  email?: string;
  onChange?: () => void;
  textCta?: string;
};
const EmailPreview = t0 => {
  const $ = _c(4);
  const {
    email,
    onChange,
    textCta
  } = t0;
  let t1;
  if ($[0] !== email || $[1] !== onChange || $[2] !== textCta) {
    t1 = email ? <div className="flex items-center bg-secondary rounded gap-3 p-4"><div className="flex gap-2 items-center flex-1 min-w-0"><div><IcoEmail24 color="primary" /></div><div className="text-label-2 text-primary truncate" data-dd-privacy="mask">{email}</div></div>{onChange ? <LinkButton onClick={onChange}>{textCta || "Change"}</LinkButton> : null}</div> : null;
    $[0] = email;
    $[1] = onChange;
    $[2] = textCta;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default EmailPreview;